import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../img/logo.svg';
import './Breadcrumbs.css';

interface Props {
  brand: string
  items: Array<{text: string | JSX.Element, link: string}>
}

function Breadcrumbs(props: Props): JSX.Element {
  const { brand, items } = props;

  return (
    <div className="breadcrumbs">
      <Link to="/">
        <img className="logo" src={logo} alt={brand} />
      </Link>
      { items.map((item) => <Link key={`${item.text}-${item.link}`} className="breadcrumb" to={item.link}>{item.text}</Link>)}
    </div>
  );
}

export default Breadcrumbs;
